window.addEventListener('online', onlineMode)
window.addEventListener('offline', offlineMode)

const toast = document.getElementById('toast')

if (!navigator.onLine) {
    offlineMode()
}

function onlineMode() {
    document.head
    .querySelector('meta[name=theme-color]')
    .setAttribute('content', '#f26c4f')

    document.body.classList.remove('offline')

    toast.classList.remove('show')
}

function offlineMode() {
    document.head
    .querySelector('meta[name=theme-color]')
    .setAttribute('content', '#153342')

    document.body.classList.add('offline')

    toast.innerHTML = 'You are browsing in offline mode'
    toast.classList.add('show')
}



//////////////////
// WEBPACK FOOTER
// ./src/js/app.js
// module id = cbRa
// module chunks = 0